import { render, staticRenderFns } from "./circle.vue?vue&type=template&id=63d922b6&scoped=true"
import script from "./circle.vue?vue&type=script&lang=js"
export * from "./circle.vue?vue&type=script&lang=js"
import style0 from "./circle.vue?vue&type=style&index=0&id=63d922b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d922b6",
  null
  
)

export default component.exports